import JsPDF from "jspdf";

export default {
  methods: {
    toPdf(canvas, { filename = "report" } = {}) {
      const encodedImg = canvas.toDataURL("image/png");
      const canvasRatio = canvas.width / canvas.height;
      const pdfImgWidth = 250;
      const pdfImgHeight = pdfImgWidth / canvasRatio;

      const doc = new JsPDF("landscape");
      doc.addImage(encodedImg, "png", 10, 10, pdfImgWidth, pdfImgHeight);
      doc.save(`${filename}.pdf`);
    }
  }
};
